import { Popover } from "lib/miolo";
import type { ReactElement } from "react";
import * as React from "react";
import { Hover } from "react-powerplug";

export interface ITooltipState {
  ref: React.Ref<any>;
  accessibility: Record<string, unknown>;
  bind: {
    onMouseEnter: () => void;
    onMouseLeave: () => void;
  };
}

export interface ITooltipProps {
  id: string;
  placement: "top" | "right" | "bottom" | "left";
  backgroundColor?: string | undefined;
  arrowColor?: string | undefined;
  render: () => any;
  children: (state: ITooltipState) => ReactElement;
}

export default function Tooltip({ id, placement, backgroundColor, arrowColor, render, children }: ITooltipProps) {
  return (
    <Hover>
      {({ hovered, bind }) => {
        return (
          <Popover
            id={id}
            isOpen={hovered}
            placement={placement}
            backgroundColor={backgroundColor}
            arrowColor={arrowColor}
            render={render}
            containerStyle={{
              zIndex: 11,
            }}
          >
            {({ accessibility, ref }) => {
              return children({
                accessibility,
                ref,
                bind,
              });
            }}
          </Popover>
        );
      }}
    </Hover>
  );
}
